import { Icon, IconProps } from "./Icon";

export function IconHdmi(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M23 4V1a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v3h-1v5.16A1.83 1.83 0 0 0 16.83 11H19c-.07 10.85-1.78 12-2.53 12-1.47 0-2.06-4.74-2.47-8.59C13.33 9.07 12.73 4 9.94 4 8 4 7.73 6.07 7.43 8.24 7 11.67 6.39 16 0 16v1c7.26-.09 8-5.25 8.41-8.66C8.74 6 9 5 9.94 5c1.9 0 2.52 5.27 3 9.51.6 5.1 1.12 9.51 3.51 9.51S20 19.88 20 11h2.17A1.83 1.83 0 0 0 24 9.16V4Zm-6-3h5v3h-5Zm6 8.16a.83.83 0 0 1-.83.83h-5.34a.83.83 0 0 1-.83-.83V5h7Z" />
    </Icon>
  );
}
